// document.querySelectorAll('.button-accordion').forEach(button => {
//     // console.log('Accordion button:', button);
//     button.addEventListener('click', () => {
//         // console.log('Accordion button clicked:', button);
//         const accordionCollapse = button.closest('.accordion-item').querySelector('.accordion-collapse');

//         if (button.classList.contains('collapsed')) {
//             // The accordion item is about to open
//             accordionCollapse.classList.add('show');
//             // console.log('Accordion item is open:', accordionCollapse);
//         } else {
//             // The accordion item is open and will close
//             accordionCollapse.classList.remove('show');
//             button.classList.add('collapsed');
//             // console.log('Accordion item is closed:', accordionCollapse);
//         }
//     });
// });